import React, { useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import faqBanner from "../../Images/student-services/ragging.webp";
import classroomImage from "../../Images/gov-body/rules.webp";
import { Row } from "react-bootstrap";

const body = [
    { name: "Bhuneshwar", remarks: "President" },
    { name: "Dr. B. P. Bhol", remarks: "Registrar" },
    { name: "Dr. Sandeep Kumar Sahu", remarks: "Proctor" },
    { name: "Dr. N. K. Swamy", remarks: "Dean Academics" },
    { name: "Ahilya", remarks: "Student Representative" },
    { name: "Urvashi", remarks: "Student Representative" },
    { name: "Dhanraj", remarks: "Student Representative" },
    { name: "Yashvant", remarks: "Student Representative" },
    { name: "Chameli Sahu", remarks: "Student Representative" },
    { name: "Yugal Ratre", remarks: "Student Representative" },
    { name: "Vikas", remarks: "Student Representative" },
    { name: "Jivan Lal", remarks: "Student Representative" },
    { name: "Thakeshwar Nayak", remarks: "Student Representative" },
    { name: "Devendra Kumar", remarks: "Student Representative" },
    { name: "Preeti", remarks: "Student Representative" }
];

const StudentCouncil = () => {
    return (
        <>
            <title>ISBM University – Student Council for Campus Engagement</title>
            <meta
                name="description"
                content="ISBM University’s Student Council bridges students & administration, fostering leadership, teamwork & active campus participation. Get involved today!"
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${faqBanner})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Student Council</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    Student Council
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-light">
                <div className="container-xxl ptb-50">
                    <Row className="m-0">
                        <div className="col-md-6">
                            <div className="governing-image-wrapper shadow">
                                <img src={classroomImage} alt="Governing Body" />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <h2 className="modern-title text-blue">Student Council</h2>
                            <div className="underline-divider mb-3"></div>
                            <p className="text-muted">
                                The Student Council at ISBM University serves as the voice of the student body,
                                playing an active role in representing student interests and enhancing campus life.
                                Comprising elected student representatives, the council acts as a bridge between
                                students and the university administration, ensuring open communication and collaboration.
                            </p>
                            <p className="text-muted">
                                The council is involved in planning and organizing academic, cultural, and
                                social activities, promoting leadership, responsibility, and teamwork among students.
                                Through regular meetings, events, and feedback sessions, the Student Council works to
                                create a vibrant, inclusive, and student-friendly environment, supporting ISBM University’s
                                commitment to holistic development and participative governance.
                            </p>
                        </div>
                    </Row>
                </div>
            </section>


            <section className="visa-section py-5 bg-light">
                <div className="container-xxl">
                    <h2 className="text-center modern-title text-blue">Student Council</h2>
                    <div className="underline-center mb-5 mx-auto"></div>
                    <div className="row m-0">
                        {body.map((member, index) => (
                            <div className="col-lg-4 col-md-6 d-flex mb-3" key={index}>
                                <div className="visa-box p-4 shadow w-100 h-100 d-flex flex-column">
                                    <div className="visahead">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="text-dark mb-0">{member.name}</h5>
                                            <span className="badge designation ms-2 ">
                                                {member.designation}
                                            </span>
                                        </div>
                                        <div className="underlinetwo"></div>
                                    </div>
                                    <ul className="mb-0 list-unstyled">
                                        <li>{member.remarks}</li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default StudentCouncil;
